import React from 'react'
import ServicesData from '../data/HomePage.json';
import { Row } from "react-bootstrap";
import { Link } from 'react-router-dom';

import { FaLaptopCode } from "react-icons/fa";

const colors = ["#faeeee", "#eeeaf1", "#f2f4e8", "#e0f7fa"];

const getSeriveIcon = (name) => {
    switch (name.toLowerCase()) {
        case 'enterprise software development':
            return <div className='rounded p-2'><i class="fi fi-tr-display-code display-4" style={{ "color": "#df797c" }}></i></div>;
        case 'web application development':
            return <div className='rounded p-2'><i class="fi fi-tr-browser display-4" style={{ "color": "#9763bcff" }}></i></div >;
        case 'build & manage offshore teams':
            return <div className='rounded p-2'><i class="fi fi-tr-employees display-4" style={{ "color": "#8a9a53ff" }}></i></div >;
        default:
            return <div style={{ "background-color": "#df797c" }} className='rounded p-2'><FaLaptopCode size={40} /></div >;
    }
};

export default function Services() {
    const { services } = ServicesData;
    return (
        <section className='padding-section-large px-5'>
            <Row className='mb-4 text-center'>
                <h1 className='pb-5 heading-style'>What <span className='main-name'>We do?</span></h1>
            </Row>
            <div className='plans-wrap'>
                {services.map((service, index) => (
                    <div key={service.id} className="p-4 rounded-24 col shadow-sm" style={{
                        backgroundColor: colors[index % colors.length]
                    }}>
                        <div className="d-flex align-items-start pb-3">
                            <div className="">
                                {getSeriveIcon(service.name)}
                            </div>
                            <h3 className="mx-2">{service.name}</h3>
                        </div>
                        <p className=''>{service.description}</p>
                        <Link to={service.link} className='text-xs float-end btn d-flex align-items-center'><span>Read more</span> <i class="fi fi-rr-arrow-small-right" style={{ "font-size": "20px", "line-height": "10px" }}></i></Link>
                    </div>
                ))}
            </div>
        </section>
    )
}
